module.exports = __webpack_public_path__ + "img/bus.497ba024.png";